export default __webpack_public_path__ + "static/media/uppercase-logo.11113e63.svg";